






import Vue, { PropType } from 'vue';
import { genDownloadImageUrl, sizes } from '@/modules/image';

export default Vue.extend({
  name: 'GItemTableImage',
  props: {
    id: {
      type: String as PropType<string>,
      required: true,
      default: null,
    },
  },
  asyncComputed: {
    async imageUrl(): Promise<string | null> {
      const u = await genDownloadImageUrl(
        sizes.x256,
        this.id,
      );
      return u;
    },
  },
});
